import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import { DocumentTextIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { ActivityIcon } from "lucide-react";
import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { vehicleRecordQuery } from "@/app/Vehicles/GraphQL/vehicleRecordQuery";
import { useVehicleActions } from "@/app/Vehicles/Hooks/useVehicleActions";
import { Badge } from "@/components/catalyst/badge";

export function VehicleRecordScreen() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/vehicles/$id",
  });

  const { data } = useSuspenseGqlQuery(vehicleRecordQuery, {
    id: match.params.id,
  });

  const vehicle = data.vehicle;

  const actions = useVehicleActions()(vehicle);

  return (
    <RecordScreen
      tabParams={{ id: vehicle.id }}
      actionsGroups={actions}
      title={vehicle.name}
      badges={
        vehicle.archived_at ? <Badge color="purple">archived</Badge> : null
      }
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/vehicles/$id",
          params: (prev) => prev,
          Icon: DocumentTextIcon,
        },
        {
          name: "Images",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/vehicles/$id/images",
          params: (prev) => prev,
          Icon: PhotoIcon,
        },
        {
          name: "Activity",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/vehicles/$id/activity",
          params: (prev) => prev,
          Icon: ActivityIcon,
        },
      ]}
    />
  );
}
